import React from 'react';
import { View, Text, TouchableOpacity, Clipboard } from 'react-native';
import { LinearGradient } from "expo-linear-gradient";

import HeaderDefault from '../../components/HeaderDefault';
import { toast } from '../../utils/toast';

import styles from './styles';

const BankSlip = () => {
    function copyBarCode(barCode) {
        Clipboard.setString(barCode);
        toast("Copiado para área de transferência.", "green");
    }

    return (
        <>
            <HeaderDefault title={"Boleto bancário"} />

            <View style={styles.container}>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor do boleto:</Text>
                    <Text>XXX,XXX.XXBRL</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Validade:</Text>
                    <Text>XX/XX/2021</Text>
                </View>

                <View style={styles.hr} />

                <Text style={styles.textInfoPayment}>
                    O reconhecimento do pagamento pode demorar <Text style={{ fontWeight: 'bold' }}>até 2 dias úteis.</Text>
                </Text>

                <Text style={styles.infoNumberBankSplip}>
                    Utilize o número do código de barras abaixo para realizar o pagamento:
                </Text>

                <Text style={styles.barCode}>
                    00000.00000 00000.000000 00000.000000 0 000000000000000
                </Text>
            </View>

            <TouchableOpacity style={styles.contentSendEmail}>
                <Text style={styles.textSendEmail}>Enviar por e-mail</Text>
            </TouchableOpacity>

            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={() => copyBarCode('00000.00000 00000.000000 00000.000000 0 000000000000000')}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}>COPIAR CÓDIGO</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
}

export default BankSlip;